<template>
  <span v-if="showable" :class="spanStateClass" class="tag">
    <i v-if="type=='status'" class="tag__prefix-icon"></i>
    <span class="tag__title">
      <slot></slot>
    </span>
    <i v-if="type=='text'" class="tag__title--clear aid aid-close" @click.stop="$_onIClick"></i>
  </span>
</template>
<script>
export default {
  props: {
    state: {
      type: String,
      validator(value) {
        let validList = [
          'success',
          'danger',
          'dark',
          'warning',
          'muted',
          'info'
        ]
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true
          }
        }
        return false
      }
    },
    type: {
      type: String,
      validator(value) {
        // 可以用ES6写法优化
        let validList = ['text', 'pill', 'status']
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true
          }
        }
        return false
      }
    }
  },
  data() {
    return {
      showable: true
    }
  },
  computed: {
    spanStateClass() {
      return [
        this.type ? 'tag--' + this.type : '',
        this.state ? 'tag--' + this.state : ''
      ]
    }
  },
  methods: {
    // 删除自己
    $_onIClick(e) {
      this.showable = false
      this.$emit('on-close', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// tag.vue?559aff46